import React from 'react';

class SubcatLevel2 extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const filter = this.props.filter
        const category = this.props.category
        const activeClass = this.props.activeCat == category ? "main-panel__subcat-title active" : "main-panel__subcat-title"
        const panoUrl = this.props.panourl ? this.props.panourl : '#'

        return (
            <a href={panoUrl} onClick={(e) => this.props.onClick(filter, category, e)} className={activeClass}>
                {this.props.title}
            </a>
        )
    }
}

export default SubcatLevel2;